import moment from 'moment';

import { enum as payoutStatuses } from '../../../../../../../../../../../../enums/payout-statuses';

function getCredentialClassName(affiliate, payoutStatus) {
	const lastCredChange = affiliate.last_current_credential_change_date;
	const lastPaidPayout = affiliate.latest_paid_payout_date;

	if (!lastCredChange || payoutStatus === payoutStatuses.paid || payoutStatus === payoutStatuses.rejected) {
		return;
	}

	if (!lastPaidPayout || moment(lastCredChange).isAfter(moment(lastPaidPayout))) {
		return 'red';
	}
}

export default getCredentialClassName;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-credentials/helpers/get-credential-class-name.js